import pug from 'javascripts/premium/templates/premium_icon.jst.pug';
window.JST = window.JST || {};
window.JST['premium/templates/premium_icon'] = pug;
